<template>
  <div class="page-add">
    <div class="add-title">办班计划详情</div>
    <div class="detail-item">
      <div class="item-label">关联申报：</div>
      <div class="item-content">{{ info.reportName }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">申报部门：</div>
      <div class="item-content">{{ info.reportDeptName }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">班级名称：</div>
      <div class="item-content">{{ info.className }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">培训时间：</div>
      <div class="item-content">{{ info.trainTime }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">培训天数：</div>
      <div class="item-content">{{ info.trainDays }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">培训地点：</div>
      <div class="item-content">{{ info.trainPlace }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">承办单位：</div>
      <div class="item-content">{{ info.undertakeUnit }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">参训人数：</div>
      <div class="item-content">{{ info.trainNum }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">人均经费：</div>
      <div class="item-content">{{ info.perFunds }}元</div>
    </div>
    <div class="detail-item">
      <div class="item-label">参训对象：</div>
      <div class="item-content">{{ info.trainPerson }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">培训内容：</div>
      <div class="item-content">{{ info.desc }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">是否外出考察(选填)：</div>
      <div class="item-content">{{ info.externalInvestigation }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">联系人(选填)：</div>
      <div class="item-content">{{ info.liaison }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">联系方式(选填)：</div>
      <div class="item-content">{{ info.liaisonPhone }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">分管领导(选填)：</div>
      <div class="item-content">{{ info.leader }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">分管领导联系方式(选填)：</div>
      <div class="item-content">{{ info.leaderPhone }}</div>
    </div>
    <div class="detail-item" v-if="attachment.length > 0">
      <div class="item-label">附件(需盖单位公章)：</div>
      <div class="item-content">
        <downItem :source="JSON.parse(info.attachment)[0]" />
      </div>
    </div>
    <div class="text-center">
      <el-button size="small" @click="$router.go(-1)">返回</el-button>
    </div>
  </div>
</template>

<script>
import downItem from "@/views/declareClassPlan/detail/downItem.vue";
import { classReportPlanInfo } from "@/api/studyService";

export default {
  components: {
    downItem,
  },
  data() {
    return {
      info: {},
      attachment: [],
    };
  },
  created() {
    const { uuid } = this.$route.query;
    classReportPlanInfo({ uuid }).then(({ code, data }) => {
      if (code !== 0) return;
      this.info = data;
      let attachment = JSON.parse(data.attachment) || "";
      if (attachment.length > 0) {
        this.attachment = attachment;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.detail-item {
  display: flex;
  font-size: 14px;
  line-height: 40px;
}
.item-label {
  width: 180px;
  text-align: right;
}
.item-content {
  width: calc(100% - 180px);
}
</style>
